<template>
  <div>
    <div class="set-bg">
      <div>
        <span class="title">血氧</span>
        <van-row>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.boMin" label="大于" placeholder="请输入"/>
          </van-col>
          <!--<van-col span="12">
            <van-field v-model="value" label="或小于" placeholder="请输入"/>
          </van-col>-->
        </van-row>
        <van-divider />
      </div>

      <div>
        <span class="title">HGB 血红蛋白</span>
        <van-row>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.hemoglobinAdultManMin" label="大于" placeholder="请输入"/>
          </van-col>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.hemoglobinAdultManMax" label="或小于" placeholder="请输入"/>
          </van-col>
        </van-row>
        <van-divider />
      </div>

      <div>
        <span class="title">血流速度</span>
        <van-row>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.braArteryMin" label="大于" placeholder="请输入"/>
          </van-col>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.braArteryMax" label="或小于" placeholder="请输入"/>
          </van-col>
        </van-row>
        <van-divider />
      </div>

      <div>
        <span class="title">心率</span>
        <van-row>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.hrMin" label="大于" placeholder="请输入"/>
          </van-col>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.hrMax" label="或小于" placeholder="请输入"/>
          </van-col>
        </van-row>
        <van-divider />
      </div>

      <div>
        <span class="title">葡萄糖(清晨空腹)</span>
        <van-row>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.fbsMin" label="大于" placeholder="请输入"/>
          </van-col>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.fbsMax" label="或小于" placeholder="请输入"/>
          </van-col>
        </van-row>
        <van-divider />
      </div>

      <div>
        <span class="title">葡萄糖(2小时餐后)</span>
        <van-row>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.pbsMin" label="大于" placeholder="请输入"/>
          </van-col>
          <van-col span="12">
            <van-field tpye="number" v-model="addForm.pbsMax" label="或小于" placeholder="请输入"/>
          </van-col>
        </van-row>
        <van-divider />
      </div>
    </div>
    <van-button class="btn" @click="submit">保 存</van-button>
  </div>
</template>

<script>
import { getAccountId } from '@/utils/auth'
import { getSugarConfigInfo, setSugarConfigInfo } from '@/api/health'
import { isNumber } from '@/utils/tool'
import { Toast } from 'vant'
export default {
  data() {
    return {
      accountId: getAccountId(),
      addForm: {
        // 血氧最小值
        boMin: '',
        // HGB 血红蛋白
        hemoglobinAdultManMin: 0,
        hemoglobinAdultManMax: 0,
        // 血流速度
        braArteryMin: 0,
        braArteryMax: 0,
        // 心率
        hrMin: 0,
        hrMax: 0,
        // 葡萄糖(清晨空腹)
        fbsMin: 0,
        fbsMax: 0,
        // 葡萄糖(2小时餐后)
        pbsMin: 0,
        pbsMax: 0
      }
    }
  },
  created() {
    this.getConfigData()
  },
  methods: {
    getConfigData: function() {
      var this_ = this
      getSugarConfigInfo({}).then(res => {
        if (res && res.data.code === 0) {
          var data = res.data.data
          if (data) {
            this_.addForm = data
            /* // 血氧最小值
            this_.addForm.boMin = data.boMin
            // HGB 血红蛋白
            this_.addForm.hemoglobinAdultManMin = data.hemoglobinAdultManMin
            this_.addForm.hemoglobinAdultManMax = data.hemoglobinAdultManMax
            // 血流速度
            this_.addForm.bArteryMin = data.barteryMin
            this_.addForm.bArteryMax = data.barteryMax
            // 心率
            this_.addForm.hrMin = data.hrMin
            this_.addForm.hrMax = data.hrMax
            // 葡萄糖(清晨空腹)
            this_.addForm.fbsMin = data.fbsMin
            this_.addForm.fbsMax = data.fbsMax
            // 葡萄糖(2小时餐后)
            this_.addForm.pbsMin = data.pbsMin
            this_.addForm.pbsMax = data.pbsMax*/
          }
        }
      })
    },
    submit: function() {
      var this_ = this
      var data = this_.addForm
      if (!isNumber(data.boMin)) {
        return Toast({
          message: '血氧值格式错误',
          duration: 1500
        })
      }
      if (!isNumber(data.hemoglobinAdultManMin) || !isNumber(data.hemoglobinAdultManMax)) {
        return Toast({
          message: 'HGB血红蛋白值格式错误',
          duration: 1500
        })
      }
      if (!isNumber(data.braArteryMin) || !isNumber(data.braArteryMax)) {
        return Toast({
          message: '血流速度值格式错误',
          duration: 1500
        })
      }
      if (!isNumber(data.hrMin) || !isNumber(data.hrMax)) {
        return Toast({
          message: '心率值格式错误',
          duration: 1500
        })
      }
      if (!isNumber(data.fbsMin) || !isNumber(data.fbsMax)) {
        return Toast({
          message: '葡萄糖(清晨空腹)值格式错误',
          duration: 1500
        })
      }
      if (!isNumber(data.pbsMin) || !isNumber(data.pbsMax)) {
        return Toast({
          message: '葡萄糖(2小时餐后)值格式错误',
          duration: 1500
        })
      }
      // string 转 float
      for (var key in data) {
        if (key !== 'updateTime') {
          var item = data[key]
          data[key] = parseFloat(item)
        }
      }
      this_.addForm.accountId = this.accountId
      setSugarConfigInfo(this_.addForm).then(res => {
        if (res && res.data.code === 0) {
          this_.$router.push('/home')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .title{
    font-size: 18px;
    padding-left: 14px;
    color: #171717;
    font-family:PingFangSC-Medium;
    font-weight:500;
    line-height:21px;
  }
  .set-bg{
    background-color: white;
    padding-top: 16px;
  }
  .btn {
    width: 92%;
    margin: 30px 4% 0;
    background: #F18937;
    color: #fff;
    border-radius:22px;
    font-size: 18px;
  }
  .van-cell {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0.2rem 0.3rem;
    overflow: hidden;
    color: #7D7D7D;
    font-size: 16px;
    line-height: 0.48rem;
    background-color: #fff;
  }
  .van-divider {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    margin: 0.3rem 0;
    color: #969799;
    line-height: 0.01rem;
    border-color: #ebedf0;
    border-style: solid;
    border-width: 0;
    margin-top: 1px;
  }
</style>
